import { HugeiconsIcon } from "@hugeicons/react"
import { Attachment01Icon } from "@hugeicons/core-free-icons"

interface AttachmentDataPart {
  // Live runtime data has these (from useChatPanel.pendingAttachments):
  id?: number
  url?: string | null
  original_name?: string
  // Server-side transcript shape has these:
  name?: string
  content_type?: string
}

interface AttachmentUIProps {
  data: AttachmentDataPart
}

export function AttachmentUI({ data }: AttachmentUIProps) {
  const url = data.url ?? null
  const filename = data.name ?? data.original_name ?? "attachment"
  const contentType = data.content_type ?? ""
  const isImage = contentType.startsWith("image/")

  return (
    <a
      href={url ?? "#"}
      target={url ? "_blank" : undefined}
      rel="noopener noreferrer"
      className="mt-1.5 inline-flex max-w-full items-center gap-2 rounded-md bg-background/40 px-2 py-1.5 ring-1 ring-border/60 hover:bg-background/60 transition-colors"
    >
      {isImage && url ? (
        <img
          src={url}
          alt={filename}
          className="h-10 w-10 rounded object-cover"
        />
      ) : (
        <div className="flex h-10 w-10 items-center justify-center rounded bg-muted">
          <HugeiconsIcon
            icon={Attachment01Icon}
            size={16}
            className="text-muted-foreground"
          />
        </div>
      )}
      <span
        className="max-w-[180px] truncate text-xs font-medium"
        title={filename}
      >
        {filename}
      </span>
    </a>
  )
}
